import { render, staticRenderFns } from "./transportationList.vue?vue&type=template&id=b8258440"
import script from "./transportationList.vue?vue&type=script&lang=js"
export * from "./transportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports